"use client";
import giftCardBannerRtl from "@/assets/landingPage/gift-card/hero-rtl.png";
import giftCardBanner from "@/assets/landingPage/gift-card/hero.png";
import { useDocumentDirection } from "@/hooks/useDocumentDirection";
import Image from "next/image";
import Link from "next/link";
import TextReveal from "../animation/TextReveal";
const GiftCardBanner = ({ data }) => {
  const dir = useDocumentDirection();

  return (
    <div
      className="gift-card-page bg-cover bg-no-repeat w-full h-full pt-[120px] sm:pt-[140px] lg:pt-[180px] xl:pt-[221px] pb-[30px] sm:pb-[50px] md:pb-[80px] xl:pb-[100px]"
      style={{
        backgroundImage: `url(${
          dir === "rtl" ? giftCardBannerRtl.src : giftCardBanner.src
        })`,
      }}
    >
      <div className="custom-container mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-7.5">
          <div>
            <TextReveal direction="left" delay={0.1} duration={1}>
              <h2 className="title-design-lg mb-4 w-full sm:w-[90%]">
                {data?.hero_title}
              </h2>
            </TextReveal>
            <TextReveal direction="left" delay={0.2} duration={1.3}>
              <p className="text-[16px] md:text-[18px] font-medium text-user-paragraph mb-5 lg:mb-10 w-[90%]">
                {data?.hero_description}
              </p>
            </TextReveal>

            <TextReveal direction="left" delay={0.3} duration={1.6}>
              <div>
                <Link
                  href={data?.hero_button_url}
                  target={
                    data?.hero_button_target === "_self" ? "_self" : "_blank"
                  }
                  className="group primary-button !px-[30px]"
                >
                  <span className="primary-button-hover-effect"></span>
                  <span className="primary-button-text">
                    {data?.hero_button_label}
                  </span>
                </Link>
              </div>
            </TextReveal>
          </div>
          <div>
            <div className="mt-0 3xl:mt-[150px]">
              <TextReveal direction="right" delay={0.1} duration={1}>
                <div className="max-w-[479px] h-auto mx-auto">
                  <Image
                    src={data?.hero_image}
                    alt="gift-card"
                    width={1000}
                    height={1000}
                    className="w-full h-full object-cover"
                  />
                </div>
              </TextReveal>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GiftCardBanner;
